import { SvgIconProps } from './icon-props';

export default function Warning(props: SvgIconProps) {
	const { height = 20, width = 20, fill = '#C57907' } = props;
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M10.6309 1.375C5.45313 1.375 1.25586 5.57227 1.25586 10.75C1.25586 15.9277 5.45313 20.125 10.6309 20.125C15.8086 20.125 20.0059 15.9277 20.0059 10.75C20.0059 5.57227 15.8086 1.375 10.6309 1.375ZM10.6309 19.5C5.79832 19.5 1.88086 15.5825 1.88086 10.75C1.88086 5.91746 5.79832 2 10.6309 2C15.4634 2 19.3809 5.91746 19.3809 10.75C19.3809 15.5825 15.4634 19.5 10.6309 19.5Z"
				fill="#C57907"
			/>
			<path
				d="M10.6323 14.2248C10.2108 14.2248 9.86914 14.5665 9.86914 14.988C9.86914 15.4094 10.2108 15.7511 10.6323 15.7511C11.0537 15.7511 11.3954 15.4094 11.3954 14.988C11.3954 14.5665 11.0537 14.2248 10.6323 14.2248ZM11.2854 8.95859V5.93359H9.97914V8.95859L10.3229 12.6098H10.9416L11.2854 8.95859Z"
				fill={fill}
			/>
		</svg>
	);
}
